import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { useSelector } from 'react-redux'

import Header from './common/Header';
import Footer from './common/Footer';

import ImageBoard from './component/ImageBoard';
import Mbko from './mbko/Mbko';
import HOC from './mbko/HOC';
import PB_A from './mbko/PB_A';
import PB_B from './mbko/PB_B';
import AQU from './mbko/AQU';
import BLO from './mbko/BLO';
import CEN from './mbko/CEN';
import GIZ from './mbko/GIZ';
import T2R_A from './mbko/T2R_A';
import T2R_B from './mbko/T2R_B';
import MMD from './mbko/MMD';
import MLG from './mbko/MLG';
import Main from './component/Main';
import Board from './component/Board';
import History from './component/History';
import Welcome from './component/Welcome';
import Chart from './component/Chart';
import WelcomeMap from './component/WelcomeMap';
import Login from './component/Login'

import Using from './component/Using';
import Personal from './component/Personal';
import NoEmail from './component/NoEmail';

import CoachInfo from './component/CoachInfo';
import RefereeInfo from './component/RefereeInfo';

import Making from 'common/Making';

function App() {

  let id = useSelector(state => state.userInfo.id)

  return (
    <div className="App" >
      <BrowserRouter>
        <Header />
        <Routes>
          <Route exact path="/" element={<Main />} />
          <Route exact path="/mbko" element={<Mbko />} />
          <Route exact path="/mbko/HOC" element={<HOC />} />
          <Route exact path="/mbko/AQU" element={<AQU />} />
          <Route exact path="/mbko/BLO" element={<BLO />} />
          <Route exact path="/mbko/CEN" element={<CEN />} />
          <Route exact path="/mbko/GIZ" element={<GIZ />} />
          <Route exact path="/mbko/PB_A" element={<PB_A />} />
          <Route exact path="/mbko/PB_B" element={<PB_B />} />
          <Route exact path="/mbko/T2R_A" element={<T2R_A />} />
          <Route exact path="/mbko/T2R_B" element={<T2R_B />} />
          <Route exact path="/mbko/MMD" element={<MMD />} />
          <Route exact path="/mbko/MLG" element={<MLG />} />
          <Route exact path="/imageboard" element={id ? <ImageBoard /> : <Main />} />
          <Route exact path="/:root" element={<Board />} />
          <Route exact path="/:root/:id" element={<Board />} />
          <Route exact path="/:root/:id/:rowid" element={<Board />} />
          <Route exact path="/login" element={id ? <Main /> : <Login />} />
          <Route exact path="/welcome" element={<Welcome />} />
          <Route exact path="/history" element={<History />} />
          <Route exact path="/chart" element={<Chart />} />
          <Route exact path="/map" element={<WelcomeMap />} />
          <Route exact path="/using" element={<Using />} />
          <Route exact path="/personal" element={<Personal />} />
          <Route exact path="/email" element={<NoEmail />} />
          <Route exact path="/coachinfo" element={<CoachInfo />} />
          <Route exact path="/refereeinfo" element={<RefereeInfo />} />
          <Route path="*" element={<Making />} />
          <Route exact path="/empty" element={<Making />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
